import React, { Component } from 'react'
import { FormItem, FormGroup, Type } from "../core/FormScheme";
import FormItemComponent from "./FormItemComponent";

export default class FormGroupComponent extends Component<{
    items: (FormItem | FormGroup)[]
    formKey: string
    [key: string]: any,
}> {
    render() {
        const formItems = this.props.items.map((item: FormItem | FormGroup, index) => {
            let formKey = this.props.formKey + "." + item.key
            if ((item as any).class) {
                return (
                    <FormItemComponent key={item.key} class={(item as FormItem).class} {...this.props} formKey={formKey}
                        index={index} name={item.name} item={item}></FormItemComponent>
                )
            } else {
                return (
                    <FormGroupComponent key={item.key} items={(item as FormGroup).children} formKey={formKey}
                        index={index} name={item.name} item={item}></FormGroupComponent>
                );
            }

        })
        return (
            formItems
        )
    }
}
